<template>
    <div class="pie_config chartConfig_viewDP">
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.scatter.show" @change="getRender">是否展示文本</el-checkbox>
        </div>
        <div class="chartDivConfig checkViewConfig">
            <el-checkbox v-model="config.scatter.large" @change="getRender">数据量是否优化</el-checkbox>
        </div>

        <div class="chartDivConfig selViewConfig">
            <span class="span_til">标记图形</span>
            <el-select v-model="config.scatter.symbol" placeholder="请选择标记的图形"
                       :popper-append-to-body="false" @change="getRender">
                <el-option
                        v-for="item in symbolList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                </el-option>
            </el-select>
        </div>
        <div class="chartDivConfig numViewConfig numViewConfig_unit">
            <span class="span_til">标记大小</span>
            <el-input v-model="config.scatter.symbolSize" @change="getRender" type="number" min="0"></el-input>
            <div class="unit">px</div>
        </div>
        <div class="chartDivConfig colViewConfig">
            <span class="span_til">标记颜色</span>
            <el-color-picker v-model="config.scatter.color" show-alpha @change="getRender"></el-color-picker>
        </div>
    </div>
</template>

<script>
    /**
     @author xiaoye
     @date 2020/4/24 8:04 下午
     */
    export default {
        name: 'pie_config',
        components: {},
        props: {
            type: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                symbolList: [
                    {value: 'circle', label: '圆'},
                    {value: 'rect', label: '矩型'},
                    {value: 'roundRect', label: '圆矩型'},
                    {value: 'pin', label: '标记'},
                    {value: 'arrow', label: '箭头'},
                    {value: 'none', label: '空'},
                    {value: 'triangle', label: '三角形'},
                    {value: 'emptyCircle', label: '空心圆'},
                    {value: 'diamond', label: '菱形'}
                ],
            }
        },
        computed: {
            config() {
                if (this.type === 'view') {
                    return this.$store.state.viewDP.chart.setting.params;
                } else if (this.type === 'screen') {
                    return this.$store.state.designer.chart.setting.params;
                }
            },
        },
        methods: {
            getRender() {
                if (this.type === 'view') {
                    this.$store.dispatch('viewDPRender');
                } else if (this.type === 'screen') {
                    this.$store.dispatch('screenRender');
                }
            },
        },
        mounted() {

        },
        destroyed() {

        }

    }
</script>

<style lang="less">
    .pie_config {

    }
</style>